import { Button, Group, Modal, Text } from '@mantine/core';
import type { PatientListItem } from '../types';

interface DeletePatientDialogProps {
  patient: PatientListItem | null;
  opened: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function DeletePatientDialog({
  patient,
  opened,
  loading = false,
  onConfirm,
  onClose,
}: DeletePatientDialogProps) {
  return (
    <Modal opened={opened} onClose={onClose} title='Rimuovi utente' centered>
      <Text size='sm' c='dimmed'>
        Verrà rimosso l'utente <strong>{patient?.code ?? '-'}</strong> dalla tua
        lista. Tutto lo storico delle rilevazioni corporee collegate verrà
        eliminato insieme al record.
      </Text>

      <Group justify='flex-end' mt='lg'>
        <Button variant='default' onClick={onClose} disabled={loading}>
          Annulla
        </Button>
        <Button color='red' onClick={onConfirm} loading={loading}>
          Elimina
        </Button>
      </Group>
    </Modal>
  );
}
